<div class="branch-card" [ngClass]="variantClass">
  <div class="branch-tag-row">
    <span class="branch-tag">{{ tag }}</span>
    <span class="branch-when">{{ when }}</span>
  </div>
  <h4 class="branch-title">{{ title }}</h4>
  <p class="branch-body">{{ body }}</p>

  <div class="branch-feed" *ngIf="data?.feedItems?.length">
    <div class="branch-feed-head">
      <span class="branch-feed-label" [ngClass]="{ 'branch-feed-label--cash': isCash }">
        <span class="branch-feed-pulse"
              [ngClass]="{ 'branch-feed-pulse--cash': isCash }"
              aria-hidden="true"></span>
        {{ feedLabel }}
      </span>
      <span class="branch-feed-meta">{{ feedMeta }}</span>
    </div>
    <div class="branch-offer" *ngFor="let offer of data.feedItems">
      <span class="branch-offer-name">{{ offer.name }}</span>
      <span class="branch-offer-amount"
            [ngClass]="{ 'branch-offer-amount--cash': isCash }">{{ offer.amount }}</span>
      <span class="branch-offer-note">{{ offer.note }}</span>
    </div>
  </div>

  <dl class="branch-grid-data" *ngIf="data?.dataCells?.length">
    <div class="branch-data-cell" *ngFor="let cell of data.dataCells">
      <dt>{{ cell.label }}</dt>
      <dd>{{ cell.value }}</dd>
    </div>
  </dl>

  <p class="branch-foot" *ngIf="data?.footNote">{{ data.footNote }}</p>
</div>
